import { MenuItem, MenuHeading } from '@kasasa/fbase-components/lib';

const menuItems: (MenuItem | MenuHeading)[] = [
  {
    icon: '',
    label: 'KRP',
    expanded: true,
    children: [
      { icon: '', label: 'FI Configuration', to: { name: 'fiConfiguration' } },
      { icon: '', label: 'Core Management', to: { name: 'coremanagement' } },
      { icon: '', label: 'Relationship Classification', to: { name: 'relationshipclassification' } },
      { icon: '', label: 'Transaction Classification Rules', to: { name: 'transactionclassification' } },
      { icon: '', label: 'Account Types', to: { name: 'accounttypemappingrules' } },
      { icon: '', label: 'Statement Codes', to: { name: 'statementcodemappingsrules' } },
      { icon: '', label: 'Account Status Settings', to: { name: 'accountstatussettings' } },
      { icon: '', label: 'Cycle Sets', to: { name: 'cyclesets' } },
      { icon: '', label: 'End of Cycle Email', to: { name: 'eocemailsettings' } },
      { icon: '', label: 'Processing Days & Holidays', to: { name: 'processingdaysandholidays' } },
      { icon: '', label: 'Interest Settings', to: { name: 'interestsettings' } },
      { icon: '', label: 'ATM Settings', to: { name: 'atmsettings' } },
      { icon: '', label: 'Product Mappings', to: { name: 'productmappings' } },
      { icon: '', label: 'Audit Messages', to: { name: 'auditmessages' } },
      { icon: '', label: 'Products', to: { name: 'products' } },
      { icon: '', label: 'Key Mapping Editor', to: { name: 'keymappingeditor' } }],
  },
  { icon: '', label: 'Engagement Rewards', to: { name: 'engagementRewards' } },
];

export default menuItems;
